import { AxiosError, AxiosResponse } from "axios";
// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';
import http from "../common/http-commons";
// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';
import { IGetListRequest, IResponse, IServerError } from "../models/common";
// import { IDeductionsListPayload, IDeductionsRequest, IDeductionsResponse } from '../models/deductions';
import { GridSize } from "@mui/material";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
	IDeductions,
	IDeductionsListPayload,
	IDeductionsResponse,
} from "../models/Deductions";
// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const DeductionsService = {
	getDeductions: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
		IDeductionsListPayload | IServerError | IResponse | IDeductionsResponse[]
	> => {
		try {
			const response: AxiosResponse<IDeductionsListPayload> =
				await http.get<IDeductionsListPayload>(
					"/v1/deductions/?client_id=" +
						clientId +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getById: async (
		clientId: string,
		id: string | undefined,
		navigateToLogout: (path: string) => void
	): Promise<IDeductions | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IDeductions> = await http.get<IDeductions>(
				`/v1/deductions/${id}/?client_id=${clientId}`
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IDeductions | IServerError | IResponse | any> => {
		if (requestPayload.id) {
		
			try {
				const response: AxiosResponse<IDeductions> =
					await http.put<IDeductions>(
						`/v1/deductions/${requestPayload.id}/`,
						requestPayload
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
				
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		
		try {
			const response: AxiosResponse<IDeductions> = await http.post<IDeductions>(
				`/v1/deductions/?client_id=${requestPayload.clientId}`,
				requestPayload
			);

		
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delDeductions: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
	
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/deductions/${delPayload.deductionsId}/`
			);

			if (response.status === 204) {
				return "Deductions has been deleted successfully";
			} else if (response.status === 200) {
				return "Deductions has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkDeductionses: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
		
		try {
			const response = await http.delete<string>(`/v1/deductions/`, {
				data: requestPayload.deductionsIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	archiveDeductions: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
	
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/deductions/${archivePayload.deductionsId}/`
			);

			if (response.status === 201) {
				return "Deductions has been archived successfully";
			} else if (response.status === 200) {
				return "Deductions has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
			
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getDeductionDDL: async (
		clientId: string
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/deductions/deduction-ddl?client_id=${clientId}`
		);

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
};
